module.exports = __webpack_public_path__ + "img/exclamation-mark.73bb554e.svg";